import { Component, Input } from '@angular/core';
import { InfoItem, PanelTheme } from '@frk/eds-components';
import { FundId } from '@products/types';

@Component({
  selector: 'ft-premium-discount',
  templateUrl: './premium-discount.component.html',
  styleUrls: ['./premium-discount.component.scss'],
})
export class PremiumDiscountComponent {
  @Input() premiumDiscountData: InfoItem[];
  @Input() asOfDate: string;
  @Input() fundId: FundId;
  theme: PanelTheme = 'white';

  constructor() {}
}
